export default __webpack_public_path__ + "static/media/services-bg.f1ca14a0.jpg";